module.exports = __webpack_public_path__ + "assets/images/coin-$1-print.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-$1-print.png
// module id = 1498
// module chunks = 1